import { DateTime } from 'luxon';

import { VenuePayout } from 'apis/merchant-payout-service/types';
import { PAYOUTS_ISSUED_IN_2023_WITH_2022_INTERVAL } from 'modules/payout-reports/constants';

export enum TokenStatus {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  INITIAL = 'initial',
}
const isPayoutIssuedIn2023 = (payoutId: string) => {
  return PAYOUTS_ISSUED_IN_2023_WITH_2022_INTERVAL.includes(payoutId);
};

export const isMpsPayoutReport = (report: VenuePayout) => isPayoutIssuedIn2023(report.id) || report.isMpsPayout;

/*
  If the user has not logged in yet then the GET endpoint will return 404, which means we show the initial message.

  After the user has logged in we get the token expiry date from the GET endpoint. We show different messages based on state of the token.
  1. If the token is not present then we show the initial message.
  2. If the token is up-to-date or has the expiry date of more than 3 weeks we show the info message.
  3. If the token is about to expire i.e (3 weeks before the expiry date) then we show the warning message.
  4. If the token has already expired then we show the error message.
*/
export const getTokenStatus = (expiresAt: string) => {
  const expirationDate = DateTime.fromISO(expiresAt);
  const now = DateTime.now().toUTC();

  const daysAfterTokenExpires = Math.floor(expirationDate.diff(now, 'days').days);

  let status: TokenStatus;
  if (daysAfterTokenExpires <= 0) {
    status = TokenStatus.ERROR;
  } else if (daysAfterTokenExpires <= 21) {
    status = TokenStatus.WARNING;
  } else {
    status = TokenStatus.INFO;
  }

  return { status, daysAfterTokenExpires };
};

export const fetchITAEnv = () => {
  return {
    itaUri: process.env.ITA_URI,
    clientId: process.env.ITA_CLIENT_ID,
    redirectUri: process.env.ITA_REDIRECT_URI,
  };
};
